import axios from "@/axios";

export const namespaced = true

export const state = {
    approvalStatuses: []
}

export const getters = {
        approvalStatuses: function (state) {
            return state.approvalStatuses;
        }
}
    
export const mutations = {
        SET_APPROVAL_STATUSES: (state, response) => (state.approvalStatuses = response.data),
}

export const actions = {
        async getApprovalStatuses({commit}) {
            commit('SET_APPROVAL_STATUSES', await axios.get("/api/approvalstatuses"))
        }
}
